import BookingHotel from './BookingHotel';
export default BookingHotel;
